'use client'

import React, { FC, ReactElement } from 'react'
import styles from './CollectionStat.module.css'
import classnames from 'classnames'
import Skeleton from '@/components/skeleton'
import { onKeyboardClick } from '@/utils/a11y/keyboard-click'

const CollectionStat: FC<{
	title: string
	value: any
	valueClassName?: string
	valueIcon?: React.FC<{
		className?: string
	}>
	isLoading?: boolean
	onClick?: () => void
	variant?: 'small'
	className?: string
}> = (props): ReactElement => {
	const { title, value } = props

	return (
		<div
			className={classnames(
				'flex flex-col px-6 py-3 bg-card border border-border rounded-2xl gap-1 whitespace-nowrap',
				{
					[styles.clickable]: !!props?.onClick,
					[styles.small]: props?.variant === 'small',
					[props?.className as any]: !!props.className
				}
			)}
			onClick={props?.onClick}
			role="button"
			tabIndex={0}
			onKeyDown={onKeyboardClick(props?.onClick)}
		>
			<div className="text-xs font-semibold text-muted-foreground truncate">{title}</div>
			<div className="flex items-center overflow-hidden">
				<div
					className={classnames(
						{ [props.valueClassName as any]: !!props.valueClassName },
						'text-foreground text-sm font-semibold truncate'
					)}
				>
					{props?.isLoading ? <Skeleton className={styles.skele} /> : value}
				</div>
				{props.valueIcon && <props.valueIcon className={styles.icon} />}
			</div>
		</div>
	)
}

export default CollectionStat
